// extracted by mini-css-extract-plugin
module.exports = {"headingText":"Description_headingText__F_14I","container":"Description_container__6UPvn","infoText":"Description_infoText__661EL"};